import { getPartnerRegulationLink, getPartnerName } from '@/api/headersSetting/index.js'

export function checkoutData (data, $sentry) {
  try {
    const user = JSON.parse(sessionStorage.getItem('user'))
    const typeCoverage = data.somenteRoubo ? 'THEFT' : 'COMPLETE'

    const state = {
      alias: process.env.VUE_APP_PRODUCT_NAME === 'seguro-celular' ? 'celular' : 'devices',
      sessionName: 'ciclic:device',
      purchaseApi: '/internal-cell-phones/v1/purchase',
      redirect: `/${process.env.VUE_APP_PRODUCT_NAME}/#/cadastro/confirmacao`,
      cookieGA: data.cookieGA,
      campaign: data.campaign,
      personalData: {
        birthday: '',
        cellphone: (user && user.cell && user.cell.replace(/\D/gim, '')) || '',
        cpf: '',
        email: (user && user.email) || '',
        name: (user && user.name) || '',
        uuid: data.lead ? data.lead.uuid : ''
      },
      plan: {
        imageSrc: data.default.imageSrc,
        nome: data.nome,
        deviceTypeName: data.deviceTypeName.toLowerCase(),
        parcela: data.parcela,
        parcelasPrecos: data.parcelasPrecos,
        ...(data.scorePoints && {
          scoringProgram: {
            enable: true,
            partnerName: getPartnerName(),
            points: data.scorePoints,
            regulationLink: getPartnerRegulationLink()
          }
        }),
        preco: data.preco,
        precoTotal: data.precoTotal,
        promoCode: {
          applied: !!data.promoCode,
          code: data.promoCode || null,
          enable: false,
          error: false
        },
        somenteRoubo: data.somenteRoubo,
        uuid: data.default.uuid,
        ...(data.protectedBag && {
          protectedBag: data.protectedBag
        })
      },
      default: {
        completePrice: data.default.completePrice,
        theftPrice: data.default.theftPrice,
        theftPaymentOptions: data.default.theftPaymentOptions
      },
      promo: {
        completePrice: data.promo.completePrice,
        theftPrice: data.promo.theftPrice,
        completePaymentOptions: data.promo.completePaymentOptions
      },
      ecommerceDataLayer: [
        {
          item: 'tipoCobertura',
          value: typeCoverage
        },
        {
          item: 'transactionProducts',
          value: [{
            sku: data.uuid,
            name: data.deviceTypeName,
            category: process.env.VUE_APP_PRODUCT_NAME === 'seguro-celular' ? 'Seguro Celular' : 'Seguro Dispositivos',
            price: parseFloat(data.precoTotal.replace(/,/g, '.')),
            quantity: 1
          }]
        }
      ]
    }

    if (data.isRenovation) {
      state.isRenovation = true
      state.plan.newEffectiveDate = data.newEffectiveDate
      state.address = formatAdress(data.personalData.address)
      state.personalData = formatPersonalData(data.personalData)
      state.plan.previousPolicyUuid = data.previousPolicyUuid
      state.renewalStartDate = data.renewalStartDate

      state.ecommerceDataLayer.push({
        value: {
          name: `Renovação - ${data.nome}`,
          category: process.env.VUE_APP_PRODUCT_NAME === 'seguro-celular' ? 'Seguro Celular - Renovação' : 'Seguro Equipamentos Portáteis - Renovação'
        }
      })

      if (data.discountAmount) { state.plan.promoCode.discountAmount = formatDiscount(data.discountAmount) }
    }

    sessionStorage.setItem('ciclic:product', JSON.stringify(state))
  } catch (error) {
    $sentry.logWithContext({ ctx: { step: '[checkout.js]' }, error })
    sessionStorage.setItem('ciclic:product', JSON.stringify({
      error: true
    }))
  }
}

function formatDiscount (discount) {
  if (!discount) return

  return discount.toFixed(2).replace('.', ',')
}

function formatAdress (address) {
  return {
    'city': address.city,
    'complement': address.additionalAddressInformation,
    'neighborhood': address.neighborhood,
    'state': address.state,
    'streetName': address.publicPlace,
    'streetNumber': address.numberAddress,
    'zipcode': address.zipCode
  }
}

function formatPersonalData (personalData) {
  return {
    'birthday': personalData.dateBirth && personalData.dateBirth.replace(/\//g, ''),
    'cellphone': personalData.phone.phone,
    'cpf': personalData.cpf,
    'email': personalData.email.email,
    'name': personalData.name,
    'uuid': null
  }
}
